/**
 * Das zentrale Zielfeld.
 *
 * Alle Regeln zum Zielfeld stehen hier zusammen, damit nachvollziehbar bleibt, welche
 * Regel wo umgesetzt ist (§70) — und damit die Balancing-Option `goalCell.passage` nicht
 * an mehreren Stellen ausgelegt wird.
 *
 * Zwei Dinge sind **feste Regeln** und keine Konfiguration:
 *
 * - Nur der **Fähnrich** darf das Zielfeld betreten (§19). Für jede andere Figur ist es
 *   kein legales Zielfeld — in jeder `passage`-Variante.
 * - Ein Fähnrich **auf** dem Zielfeld kann ausschließlich von einem gegnerischen Fähnrich
 *   geschlagen werden und ist nicht stoßbar (§21). Das prüft `legal-captures.ts` bzw.
 *   `legal-pushes.ts`.
 *
 * Konfigurierbar ist nur, ob das Feld **durchquert** werden darf: §19 regelt das Betreten,
 * über das Durchziehen steht dort nichts. Default `'blocked'` (User, 2026-10-02).
 */
import { hex, hexEquals } from './hex.js';
const GOAL_CELL = hex(0, 0);
/** Das Zielfeld ist das geometrische Mittelfeld. */
export function isGoalCell(cell) {
    return hexEquals(cell, GOAL_CELL);
}
/** Nur der Fähnrich darf das Zielfeld betreten (§19) — unabhängig von jeder Einstellung. */
export function mayEnterGoalCell(type) {
    return type === 'flagBearer';
}
/**
 * Darf auf diesem Feld überhaupt geschlagen werden?
 *
 * Auf dem Zielfeld kann nur ein Fähnrich stehen, und dort ist er **ausschließlich** von
 * einem gegnerischen Fähnrich schlagbar (§21). Für jede andere Figur ist das Zielfeld kein
 * Schlagziel — schon deshalb, weil sie es nicht betreten dürfte.
 */
export function mayCaptureOn(cell, attackerType) {
    if (!isGoalCell(cell))
        return true;
    return mayEnterGoalCell(attackerType);
}
/**
 * Wie das Zielfeld eine **durchziehende** Figur behindert.
 *
 * Für den Fähnrich nie — er darf dort landen und also auch darüber hinaus ziehen.
 */
export function goalCellBlocking(config, cell, type) {
    if (!isGoalCell(cell) || mayEnterGoalCell(type)) {
        return { hard: false, soft: false };
    }
    switch (config.goalCell.passage) {
        case 'open':
            return { hard: false, soft: false };
        case 'jumpersOnly':
            return { hard: false, soft: true };
        case 'blocked':
            return { hard: true, soft: false };
    }
}
//# sourceMappingURL=goal-cell.js.map